import React from 'react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import { Arrow } from 'icons/untitledui';
import * as Styled from 'form/styles/FormEditView.style';

interface NumberFieldProps {
  slug: string;
  inputType: 'number' | 'float';
}

export default function NumberField({
  slug,
  inputType,
}: NumberFieldProps): JSX.Element {
  const { values, setFieldValue } = useFormikContext<Record<string, any>>();
  const { t } = useTranslation('pageForm');
  const step = inputType === 'float' ? 0.01 : 1;

  const handleStep = (negative: boolean) => {
    const current = Number(values[slug]) || 0;
    const next = current + step * (negative ? -1 : 1);
    const formatted = inputType === 'float' ? next.toFixed(2) : String(next);
    setFieldValue(slug, formatted);
  };

  return (
    <Styled.NumberFieldWrapper>
      <Styled.NumberInput
        id={slug}
        name={slug}
        type="text"
        value={(values[slug] as string) || ''}
        onChange={(e) => setFieldValue(slug, e.target.value)}
        placeholder={t('edit.placeholder')}
      />
      <Styled.StepperGroup>
        <Styled.StepperButton
          type="button"
          aria-label={t('edit.increment')}
          onClick={() => handleStep(false)}
        >
          <Arrow.ChevronUp />
        </Styled.StepperButton>
        <Styled.StepperButton
          type="button"
          aria-label={t('edit.decrement')}
          onClick={() => handleStep(true)}
        >
          <Arrow.ChevronDown />
        </Styled.StepperButton>
      </Styled.StepperGroup>
    </Styled.NumberFieldWrapper>
  );
}
